/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	GrantAccessDialogGrantContentAccessMutation$data as GrantAccessDialogGrantContentAccessMutation,
	GrantAccessDialogGrantContentAccessMutation$variables as GrantAccessDialogGrantContentAccessMutationVariables,
} from '../__generated__/GrantAccessDialogGrantContentAccessMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { GrantAccessDialogGrantContentAccessMutation$data } from '../__generated__/GrantAccessDialogGrantContentAccessMutation.graphql.ts';
export type GrantAccessDialogGrantContentAccessMutation_grantContentAccess_GrantContentAccessPayload = NonNullable<GrantAccessDialogGrantContentAccessMutation$data['grantContentAccess']>;

// GraphQL input types re-exported from Relay artifact
export type { GrantContentAccessInput } from '../__generated__/GrantAccessDialogGrantContentAccessMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum AccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

